import {
  Chat,
  Integration,
  ProfileSettings,
  UserAddEdit,
  UserDetails,
  UserManagement,
} from '@/pages';
import { SignIn, SignUp } from '@/pages/auth';
import { Dashboard } from '@/pages/dashboard';
import {
  ChatIntegration,
  ChatIntegrationDetails,
} from '@/pages/integration/sections';
import {
  BulkProductAdd,
  ProductDetailPage,
  ProductManagement,
} from '@/pages/product-management';
import { Showroom } from '@/pages/showroom';
import AnalysisDetails from '@/pages/showroom/AnalysisDetails';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { ProductAddEdit } from '../pages/product-management/ProductAddEdit';
import CompanyGuard from './CompanyGuard';
import DashboardLayoutWrapper from './DashboardLayoutWrapper';
import ProtectedRoute from './ProtectedRoute';
import {
  BranchAddEdit,
  BranchDetail,
  BranchManagement,
} from '@/pages/branch-management';
import { AITraining } from '@/pages/AITraining/AITraining';
import { NotFound } from '@/pages/NotFound';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/dashboard" replace />,
  },
  {
    path: '/sign-in',
    element: <SignIn />,
  },
  {
    path: '/sign-up',
    element: <SignUp />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <CompanyGuard />,
        children: [
          {
            element: <DashboardLayoutWrapper />,
            children: [
              {
                path: '/dashboard',
                element: <Dashboard />,
              },
              {
                path: '/products-management',
                element: <ProductManagement />,
              },
              {
                path: '/products-management/new',
                element: <ProductAddEdit />,
              },
              {
                path: '/products-management/bulk',
                element: <BulkProductAdd />,
              },
              {
                path: '/products-management/:id',
                element: <ProductDetailPage />,
              },
              {
                path: '/products-management/:id/edit',
                element: <ProductAddEdit />,
              },
              {
                path: '/user-management',
                element: <UserManagement />,
              },
              {
                path: '/user-management/add',
                element: <UserAddEdit />,
              },
              {
                path: '/user-management/edit/:id',
                element: <UserAddEdit />,
              },
              {
                path: '/user-management/:id',
                element: <UserDetails />,
              },
              {
                path: '/branch-management',
                children: [
                  {
                    index: true,
                    element: <BranchManagement />,
                  },
                  {
                    path: 'new',
                    element: <BranchAddEdit />,
                  },
                  {
                    path: 'edit/:id',
                    element: <BranchAddEdit />,
                  },
                  {
                    path: ':id',
                    element: <BranchDetail />,
                  },
                ],
              },
              {
                path: '/showroom',
                element: <Showroom />,
              },
              {
                path: '/showroom/analysis/:analysisId',
                element: <AnalysisDetails />,
              },
              {
                path: '/chat',
                element: <Chat />,
              },
              {
                path: '/ai-training',
                element: <AITraining />,
              },
              {
                path: '/integration',

                children: [
                  {
                    index: true,
                    element: <Integration />,
                  },
                  {
                    path: 'chat-integration',
                    children: [
                      {
                        index: true,
                        element: <ChatIntegration />,
                      },
                      {
                        path: 'add',
                        element: <ChatIntegrationDetails />,
                      },
                      {
                        path: 'edit/:widgetId',
                        element: <ChatIntegrationDetails />,
                      },
                    ],
                  },
                ],
              },
              {
                path: '/profile',
                element: <ProfileSettings />,
              },

              // Add more protected dashboard routes here
            ],
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);
